/**
 * [pug template]
 */
<template lang="pug">
  select(:id="name", :name="name", v-model="selected", :disabled="disabled")
    option(v-for="value, valueRef in options", :value="valueRef", v-text="value.label", v-if="value.display", :disabled="value.disabled")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'simple-choice',
  props: {
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: [Array, Object],
      default: { label: '', display: true, disabled: false }
    },
    defaultField: {
      type: [String, Number],
      default: null
    }
  },
  data: function () {
    return {
      selected: null
    }
  },
  created: function () {
    this.selected = this.defaultField
  },
  watch: {
    selected: function (newValue, oldValue) {
      var dataEmit = newValue
      this.$emit('value-changed', dataEmit)
    },
    defaultField: function (newValue, oldValue) {
      this.selected = newValue
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// SelectComponent.vue?c5e0baa0